// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    debug: true,
    usePaymentMethodMock: false,
    production: false,
    apiPath: {
        base: 'https://insuretest.astradirect.de:8445/RestService.svc/json/',
        payment: 'https://astragateway-test.astra-versicherung.de:3443/api/invoice-service/',
    },
    apiToken: '0CC0834B-73E5-4662-80A3-4675C802B64F',
    lockersNetToken: '0CC0834B-73E5-4662-80A3-4675C802B64F',
    lockersNet: 'https://lockersnet-gw1.astradirect.de/AstraPortalService/AstraPortalService.svc/json/',
    googleAnalyticsId: 'UA-113651050-1',
    googleConversionId: 'AW-871389258',
    sendGAEvents: false,
    customerTransfer: 'OnlineRequest/CustomerData/',
    /**
     * @description id of the title that represents a company
     * or other institution ("Schule/Verein/Firma") instead of
     * a natural person. Some products (like electronics B2B)
     * can only be used by insurees with this title, while
     * most others are not available to them.
     */
    titleCompanyId: 80125,
    gtagUrl: 'https://www.googletagmanager.com/gtag/js?id=UA-113651050-1',
    generalPrivacyStatementUrl:
        'https://privacy.cortina-consult.com/privacy?id=YV1L7j6QJMDjy6zQjrVW&lang=de&script=true&json=true',
    callcenterPrivacyStatementUrl:
        'https://privacy.cortina-consult.com/privacy?id=YV1L7j6QJMDjy6zQjrVW&lang=de&script=true&json=true',
    socialMediaPrivacyStatementUrls: {
        facebook: 'https://privacy.cortina-consult.com/privacy?id=0KvM51ioeJdOhpPef8VB&lang=de&script=true&json=true',
        instagram: 'https://privacy.cortina-consult.com/privacy?id=HzdIXmwZ7wLHIjoGT8Ll&lang=de&script=false&json=true',
        tiktok: 'https://privacy.cortina-consult.com/privacy?id=NmEqBJaCRWSeXXwC2LFC&lang=de&script=true&json=true',
    },
    freshdeskApiPath: 'https://www.astra-versicherung.de/contact-form.php/',
    freshdeskApiKey: '',
    metaPixelId: 1033240021510427,
    friendlyCaptchaSiteKey: 'FCMTBFIS7A7AJC4G',
};
